import { fg } from '@atlaskit/platform-feature-flags/fg';
import { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import { type ProductKeys } from '../../../../constants/product-keys';

type FederatedEmailProduct =
	| (typeof ProductKeys3P)['Gmail']
	| (typeof ProductKeys3P)['OutlookMail'];

const isFederatedEmailProduct = (productKey: ProductKeys): productKey is FederatedEmailProduct =>
	productKey === ProductKeys3P.Gmail || productKey === ProductKeys3P.OutlookMail;

export const getFederatedEmailResultCountLimit = ({
	productKey,
	count,
	hasMoreGmailResults,
	hasMoreOutlookMailResults,
}: {
	productKey: ProductKeys;
	count?: number;
	hasMoreGmailResults?: boolean;
	hasMoreOutlookMailResults?: boolean;
}): number | undefined => {
	if (!isFederatedEmailProduct(productKey)) {
		return undefined;
	}

	if (productKey === ProductKeys3P.Gmail && !fg('formula_3p_gmail_result_count')) {
		return undefined;
	}

	const hasMoreResults =
		productKey === ProductKeys3P.Gmail ? hasMoreGmailResults : hasMoreOutlookMailResults;

	if (!hasMoreResults || count === undefined) {
		return undefined;
	}

	return count;
};
